"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJdMinHalf = exports.isJdMinRX = exports.initIsJdMinRX = exports.getJdMinUrlPrams = exports.goJdMinLogin = exports.mergeRequestLoginForJdMin = exports.jdMinLoginTokenInit = exports.isJdMin = exports.jdmin_loginWQBiz = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var wxTool_1 = require("../tools/wxTool");
var getUrlParam_1 = require("./getUrlParam");
var nethpMini_1 = require("./nethpMini");
var getGlobalWindow_1 = require("./getGlobalWindow");
exports.jdmin_loginWQBiz = "healthjd"; // healthjd.com 域名手q打通
var isJdMinRXLocal = "isJdMinRXLocal";
var JdGouRxChannelid = "10090";
// 判断当前是京购小程序
function isJdMin() {
    var wd = (0, getGlobalWindow_1.getWindow)();
    var isJinggou = /wx91d27dbf599dff74/.test(wd.navigator.userAgent.toLowerCase());
    var res = (0, wxTool_1.isMiniprogram)() && isJinggou;
    // console.log("是否是京购小程序", res);
    return res;
}
exports.isJdMin = isJdMin;
// 京购登录态打通需要cookie wq_auth_token
function jdMinLoginTokenInit() {
    if (!isJdMin()) {
        return;
    }
    var query = (0, getUrlParam_1.getUrlParam)();
    js_cookie_1.default.set("loginWQBiz", exports.jdmin_loginWQBiz, {
        expires: 7,
        domain: ".healthjd.com",
    });
    if (query.token) {
        js_cookie_1.default.set("wq_auth_token", query.token, {
            expires: 7,
            domain: ".healthjd.com",
        });
    }
}
exports.jdMinLoginTokenInit = jdMinLoginTokenInit;
// 京购小程序登录态打通配置（请求需要改成这个）
function mergeRequestLoginForJdMin(obj) {
    if (!isJdMin()) {
        console.log("京购小程序");
        return;
    }
    Object.assign(obj, {
        loginType: 1,
        loginWQBiz: exports.jdmin_loginWQBiz,
    });
}
exports.mergeRequestLoginForJdMin = mergeRequestLoginForJdMin;
function removeUrlParameter(url, parameter) {
    var urlObj = new URL(url);
    var searchParams = urlObj.searchParams;
    // 删除指定参数
    searchParams.delete(parameter);
    // 更新URL对象
    urlObj.search = searchParams.toString();
    return urlObj.href;
}
// 京购小程序登录态打通跳转
function goJdMinLogin(returnUrl) {
    var wd = (0, getGlobalWindow_1.getWindow)();
    returnUrl = returnUrl || wd.location.href;
    returnUrl = removeUrlParameter(returnUrl, "token");
    var r = encodeURIComponent(returnUrl);
    wd.location.replace("https://wq.jd.com/pinbind/pintokenredirect?biz=".concat(exports.jdmin_loginWQBiz, "&url=").concat(r));
}
exports.goJdMinLogin = goJdMinLogin;
// 京购小程序webview会带cookie参数，来获取openId啥的，为了种小程序参数用来后续支付的流程（暂时）
function getJdMinUrlPrams() {
    if (!isJdMin()) {
        return {};
    }
    var query = (0, getUrlParam_1.getUrlParam)();
    var ck = JSON.parse(decodeURIComponent(query.cookie || "{}"));
    console.log("getJdMinUrlPrams", query);
    console.log("getJdMinUrlPrams", ck);
    return {
        openId: ck.wxapp_openid,
        // md5_pin: ck.md5_pin,
        miniWexinAppId: "wx91d27dbf599dff74",
        // miniprogram: 'wxapp'
    };
}
exports.getJdMinUrlPrams = getJdMinUrlPrams;
// 判断来源于京购小程序（处方渠道)初始化本地判断
function initIsJdMinRX() {
    var query = (0, getUrlParam_1.getUrlParam)();
    if (query.channelid === JdGouRxChannelid) {
        // Cookies.set(isJdMinRXLocal, JSON.stringify(query), {
        //   expires: 1,
        //   domain: ".healthjd.com",
        // });
        sessionStorage.setItem(isJdMinRXLocal, JSON.stringify(query));
        return true;
    }
    return false;
}
exports.initIsJdMinRX = initIsJdMinRX;
// 判断来源于京购小程序（处方渠道)
function isJdMinRX() {
    if (initIsJdMinRX()) {
        return true;
    }
    // const locInfo = Cookies.get(isJdMinRXLocal);
    var locInfo = sessionStorage.getItem(isJdMinRXLocal);
    if (locInfo) {
        try {
            var locInfoData = JSON.parse(locInfo);
            return locInfoData.channelid === JdGouRxChannelid;
        }
        catch (e) {
            console.error("isJdMinRXLoc", e);
        }
    }
    return false;
}
exports.isJdMinRX = isJdMinRX;
// 判断是京购小程序下互医半屏
function isJdMinHalf() {
    if ((0, nethpMini_1.isNethpMini)() && !isJdMin() && isJdMinRX()) {
        console.log("京购小程序下互医半屏");
        return true;
    }
    console.log("不是京购小程序下互医半屏");
    return false;
}
exports.isJdMinHalf = isJdMinHalf;
